import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { useIsMobile } from "@utils/hooks";
import { AuthModal } from "@ui/components/auth/authModal";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { Row } from "@ui/components/layout";
import { useModalTools } from "@ui/modals/modalContext";
import { SubscriptionSummary } from "./subscriptionSummary";
interface SubscriberInfosProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}

export const SubscriberInfos: React.FC<SubscriberInfosProps> = ({ shareroom }) => {
	const currentProfile = useCurrentProfile();
	const { trackingService } = useServices();
	const { createModal } = useModalTools();
	const isMobile = useIsMobile();
	const isAdmin =
		shareroom.administrators.findIndex((admin) => admin.id === currentProfile?.id) >= 0 ||
		shareroom?.owner.id === currentProfile?.id;
	const handleSubscription = (): void => {
		trackingService.track("User_Subscribe to classroom");
		if (!currentProfile) {
			createModal((close) => <AuthModal close={close} />);
			return;
		}
		createModal((close) => <SubscriptionSummary shareroom={shareroom} close={close} />);
	};

	return (
		<Row gap={20}>
			{!isMobile ? (
				<ContainerSubscriber>
					<ContainerBloc>
						<PriceInfo>
							<Price>{!currentProfile ? shareroom.pricing.price : shareroom.pricing.priceInUserCurrency}</Price>
							<Currency>{!currentProfile ? shareroom.pricing.currency : shareroom.pricing.userCurrency}</Currency>
							<ByMonthly>/ {I18n.t(`shareroom.subscription.mode.${shareroom.pricing.subscriptionMode}`)}</ByMonthly>
						</PriceInfo>

						{!isAdmin && (!shareroom.subscriptionStatus || shareroom.subscriptionStatus === "EXPIRED") ? (
							<StyledButtonContainer
								onClick={() => {
									handleSubscription();
								}}
							>
								<span>{shareroom.subscriptionStatus === "EXPIRED" ? I18n.t("resubscribe") : I18n.t("subscribe")}</span>
							</StyledButtonContainer>
						) : null}
					</ContainerBloc>
				</ContainerSubscriber>
			) : (
				<ContainerSubscriberIsMobile>
					<ContainerBlocIsMobile>
						<PriceInfo>
							<Price>{!currentProfile ? shareroom.pricing.price : shareroom.pricing.priceInUserCurrency}</Price>
							<Currency>{!currentProfile ? shareroom.pricing.currency : shareroom.pricing.userCurrency}</Currency>
							<ByMonthly>/ {I18n.t(`shareroom.subscription.mode.${shareroom.pricing.subscriptionMode}`)}</ByMonthly>
						</PriceInfo>
						{shareroom?.owner.id !== currentProfile?.id && shareroom.subscriptionStatus !== "ACTIVE" && (
							<StyledButtonContainerIsMobile
								onClick={() => {
									handleSubscription();
								}}
							>
								<span>{shareroom.subscriptionStatus === "EXPIRED" ? I18n.t("resubscribe") : I18n.t("subscribe")}</span>
							</StyledButtonContainerIsMobile>
						)}
					</ContainerBlocIsMobile>
				</ContainerSubscriberIsMobile>
			)}
		</Row>
	);
};

const ContainerSubscriber = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 30px;
`;
const ContainerBloc = styled.div`
	display: flex;
	flex-direction: column;
	position: absolute;
	right: 0;
	margin-right: 50px;
`;

const ContainerSubscriberIsMobile = styled.div`
	display: flex;
	flex-direction: column;
`;
const ContainerBlocIsMobile = styled.div`
	display: flex;
	flex-direction: column;
`;

const PriceInfo = styled.div`
	display: flex;
	flex-direction: row;
	margin-bottom: 20px;
`;
const Price = styled.div`
	${({ theme }) => theme.textStyles.subtitle}
	color: #fff;
	font-size: 1.875rem;
`;
const Currency = styled.div`
	${({ theme }) => theme.textStyles.subtitle}
	color: #fff;
	font-size: 1.875rem;
	margin-left: 10px;
`;
const ByMonthly = styled.div`
	color: #fff;
	margin-left: 10px;
	margin-top: 13px;
`;
const StyledButtonContainer = styled(LoadingButton)`
	position: absolute;
	right: 0;
	top: 56px;
	/* width: 54%; */
`;

const StyledButtonContainerIsMobile = styled(LoadingButton)`
	padding: 10px !important;
	font-size: 13px;
	position: absolute;
	bottom: -20px;
	/* width: 54%; */
`;
